import * as React from 'react';
import toastr from 'react-hot-toast';
import moment, { Moment } from 'moment';
import { Grid, GridProps } from '@mui/material';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import { HistoryFilter } from 'components/History';
import { useResize } from 'hooks/common';
import 'react-dates/lib/css/_datepicker.css';
import './react_dates_overrides.css';
import { Calender } from 'components/SVG';

export type DateRange = {
  startDate: Moment;
  endDate: Moment;
};

type SparkDateRangePickerProps = {
  size?: GridProps['xs'];
  historyFilter: HistoryFilter;
  setHistoryFilter: React.Dispatch<React.SetStateAction<HistoryFilter>>;
};
type FocusedInput = 'startDate' | 'endDate';

function SparkDateRangePicker({
  size = 12,
  historyFilter,
  setHistoryFilter,
}: SparkDateRangePickerProps) {
  const { isMobile } = useResize();
  const [focusedInput, setFocusedInput] = React.useState<FocusedInput | null>(
    null
  );

  const onDatesChange = ({
    startDate,
    endDate,
  }: {
    startDate: Moment | null;
    endDate: Moment | null;
  }) => {
    if (startDate?.isAfter(historyFilter.dateRange.endDate)) {
      toastr.error('Start date must be before End date');
      return;
    }
    setHistoryFilter((previousState) => ({
      ...previousState,
      dateRange: {
        ...previousState.dateRange,
        ...(!!startDate && { startDate }),
        ...(!!endDate && { endDate }),
      },
    }));
  };

  const isOutsideRange = (date: Moment) => {
    const today = moment();
    return date.isAfter(today, 'day');
  };

  return (
    <Grid
      item
      xs={size}
      position='relative'
      className={isMobile ? 'responsive' : ''}
      sx={{ zIndex: 100 }}
    >
      <DateRangePicker
        startDate={historyFilter.dateRange.startDate}
        startDateId='startDate'
        endDate={historyFilter.dateRange.endDate}
        endDateId='endDate'
        focusedInput={focusedInput}
        onDatesChange={onDatesChange}
        onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
        displayFormat="DD MMM 'YY"
        block
        isOutsideRange={isOutsideRange}
        numberOfMonths={isMobile ? 1 : 2}
        customInputIcon={<Calender />}
        inputIconPosition='after'
      />
    </Grid>
  );
}

export default SparkDateRangePicker;
